import MainLayout from './layouts/MainLayout/MainLayout';
import PublicLayout from './layouts/PublicLayout/PublicLayout';

import Login from './pages/Login/Login';
import Home from './pages/Home/Home';
import Users from './pages/Users/Users';
import CreateUsers from './pages/CreateUsers/CreateUsers';
import UpdateUsers from './pages/UpdateUsers/UpdateUsers';
import OrderStatus from './pages/OrderStatus/OrderStatus';
import UserRoute from './routes/UserRoute';
import CreateOrderStatus from './pages/CreateOrderStatus/CreateOrderStatus';
import UpdateOrderStatus from './pages/UpdateOrderStatus/UpdateOrderStatus';
import StockStatus from './pages/StockStatus/StockStatus';
import CreateStockStatus from './pages/CreateStockStatus/CreateStockStatus';
import UpdateStockStatus from './pages/UpdateStockStatus/UpdateStockStatus';
import ShipmentStatus from './pages/ShipmentStatus/ShipmentStatus';
import CreateShipmentStatus from './pages/CreateShipmentStatus/CreateShipmentStatus';
import UpdateShipmentStatus from './pages/UpdateShipmentStatus/UpdateShipmentStatus';
import Material from './pages/Material/Material';
import CreateMaterial from './pages/CreateMaterial/CreateMaterial';
import UpdateMaterial from './pages/UpdateMaterial/UpdateMaterial';
import Yarn from './pages/Yarn/Yarn';
import CreateYarn from './pages/CreateYarn/CreateYarn';
import UpdateYarn from './pages/UpdateYarn/UpdateYarn';
import Thread from './pages/Thread/Thread';
import CreateThread from './pages/CreateThread/CreateThread';
import UpdateThread from './pages/UpdateThread/UpdateThread';
import Weave from './pages/Weave/Weave';
import CreateWeave from './pages/CreateWeave/CreateWeave';
import UpdateWeave from './pages/UpdateWeave/UpdateWeave';
import Color from './pages/Color/Color';
import CreateColor from './pages/CreateColor/CreateColor';
import UpdateColor from './pages/UpdateColor/UpdateColor';
import Unit from './pages/Unit/Unit';
import CreateUnit from './pages/CreateUnit/CreateUnit';
import UpdateUnit from './pages/UpdateUnit/UpdateUnit';
import Composition from './pages/Composition/Composition';
import CreateComposition from './pages/CreateComposition/CreateComposition';
import UpdateComposition from './pages/UpdateComposition/UpdateComposition';
import WeaveColor from './pages/WeaveColor/WeaveColor';
import CreateWeaveColor from './pages/CreateWeaveColor/CreateWeaveColor';
import UpdateWeaveColor from './pages/UpdateWeaveColor/UpdateWeaveColor';
import Currency from './pages/Currency/Currency';
import CreateCurrency from './pages/CreateCurrency/CreateCurrency';
import UpdateCurrency from './pages/UpdateCurrency/UpdateCurrency';
import WeaveType from './pages/WeaveType/WeaveType';
import CreateWeaveType from './pages/CreateWeaveType/CreateWeaveType';
import UpdateWeaveType from './pages/UpdateWeaveType/UpdateWeaveType';
import SupplierType from './pages/SupplierType/SupplierType';
import CreateSupplierType from './pages/CreateSupplierType/CreateSupplierType';
import UpdateSupplierType from './pages/UpdateSupplierType/UpdateSupplierType';
import UserDetails from './pages/UserDetails/UserDetails';
import Customer from './pages/Customer/Customer';
import CreateCustomer from './pages/CreateCustomer/CreateCustomer';
import UpdateCustomer from './pages/UpdateCustomer/UpdateCustomer';
import Supplier from './pages/Supplier/Supplier';
import CreateSupplier from './pages/CreateSupplier/CreateSupplier';
import UpdateSupplier from './pages/UpdateSupplier/UpdateSupplier';
import Stock from './pages/Stock/Stock';
import CreateStock from './pages/CreateStock/CreateStock';
import UpdateStock from './pages/UpdateStock/UpdateStock';
import Order from './pages/Order/Order';
import CreateOrder from './pages/CreateOrder/CreateOrder';
import UpdateOrder from './pages/UpdateOrder/UpdateOrder';
import OrderDetails from './pages/OrderDetails/OrderDetails';
import OrderAction from './pages/OrderAction/OrderAction';
import Product from './pages/Product/Product';
import CreateProduct from './pages/CreateProduct/CreateProduct';
import UpdateProduct from './pages/UpdateProduct/UpdateProduct';
import CustomerAgreementReport from
  './pages/Reports/CustomerAgreementReport/CustomerAgreementReport';
import CaglikReport from './pages/Reports/CaglikReport/CaglikReport';
import SampleReport from './pages/Reports/SampleReport/SampleReport';
import OrderSupplier from './pages/OrderSupplier/OrderSupplier';
import Sample from './pages/Sample/Sample';
import CreateSample from './pages/CreateSample/CreateSample';
import UpdateSample from './pages/UpdateSample/UpdateSample';


const routes = {
  PublicLayout: {
    exact: true,
    name: 'Public',
    component: PublicLayout,
    children: [
      {
        path: '/login',
        exact: true,
        name: 'Login',
        component: Login,
      },
    ],
  },
  MainLayout: {
    exact: true,
    name: 'Main',
    component: MainLayout,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        routeComponent: UserRoute,
      },
      {
        path: '/users',
        name: 'Users',
        component: Users,
        routeComponent: UserRoute,
      },
      {
        path: '/users/create',
        name: 'CreateUsers',
        component: CreateUsers,
        routeComponent: UserRoute,
      },
      {
        path: '/users/edit/:id',
        name: 'UpdateUsers',
        component: UpdateUsers,
        routeComponent: UserRoute,
      },
      {
        path: '/order-status',
        name: 'OrderStatus',
        component: OrderStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/order-status/create',
        name: 'CreateOrderStatus',
        component: CreateOrderStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/order-status/edit/:id',
        name: 'UpdateOrderStatus',
        component: UpdateOrderStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/stock-status',
        name: 'StockStatus',
        component: StockStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/stock-status/create',
        name: 'CreateStockStatus',
        component: CreateStockStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/stock-status/edit/:id',
        name: 'UpdateStockStatus',
        component: UpdateStockStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/shipment-status',
        name: 'ShipmentStatus',
        component: ShipmentStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/shipment-status/create',
        name: 'CreateShipmentStatus',
        component: CreateShipmentStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/shipment-status/edit/:id',
        name: 'UpdateShipmentStatus',
        component: UpdateShipmentStatus,
        routeComponent: UserRoute,
      },
      {
        path: '/material',
        name: 'Material',
        component: Material,
        routeComponent: UserRoute,
      },
      {
        path: '/material/create',
        name: 'CreateMaterial',
        component: CreateMaterial,
        routeComponent: UserRoute,
      },
      {
        path: '/material/edit/:id',
        name: 'UpdateMaterial',
        component: UpdateMaterial,
        routeComponent: UserRoute,
      },
      {
        path: '/yarn',
        name: 'Yarn',
        component: Yarn,
        routeComponent: UserRoute,
      },
      {
        path: '/yarn/create',
        name: 'CreateYarn',
        component: CreateYarn,
        routeComponent: UserRoute,
      },
      {
        path: '/yarn/edit/:id',
        name: 'UpdateYarn',
        component: UpdateYarn,
        routeComponent: UserRoute,
      },
      {
        path: '/thread',
        name: 'Thread',
        component: Thread,
        routeComponent: UserRoute,
      },
      {
        path: '/thread/create',
        name: 'CreateThread',
        component: CreateThread,
        routeComponent: UserRoute,
      },
      {
        path: '/thread/edit/:id',
        name: 'UpdateThread',
        component: UpdateThread,
        routeComponent: UserRoute,
      },
      {
        path: '/weave',
        name: 'Weave',
        component: Weave,
        routeComponent: UserRoute,
      },
      {
        path: '/weave/create',
        name: 'CreateWeave',
        component: CreateWeave,
        routeComponent: UserRoute,
      },
      {
        path: '/weave/edit/:id',
        name: 'UpdateWeave',
        component: UpdateWeave,
        routeComponent: UserRoute,
      },
      {
        path: '/color',
        name: 'Color',
        component: Color,
        routeComponent: UserRoute,
      },
      {
        path: '/color/create',
        name: 'CreateColor',
        component: CreateColor,
        routeComponent: UserRoute,
      },
      {
        path: '/color/edit/:id',
        name: 'UpdateColor',
        component: UpdateColor,
        routeComponent: UserRoute,
      },
      {
        path: '/unit',
        name: 'Unit',
        component: Unit,
        routeComponent: UserRoute,
      },
      {
        path: '/unit/create',
        name: 'CreateUnit',
        component: CreateUnit,
        routeComponent: UserRoute,
      },
      {
        path: '/unit/edit/:id',
        name: 'UpdateUnit',
        component: UpdateUnit,
        routeComponent: UserRoute,
      },
      {
        path: '/composition',
        name: 'Composition',
        component: Composition,
        routeComponent: UserRoute,
      },
      {
        path: '/composition/create',
        name: 'CreateComposition',
        component: CreateComposition,
        routeComponent: UserRoute,
      },
      {
        path: '/composition/edit/:id',
        name: 'UpdateComposition',
        component: UpdateComposition,
        routeComponent: UserRoute,
      },
      {
        path: '/weavecolor',
        name: 'WeaveColor',
        component: WeaveColor,
        routeComponent: UserRoute,
      },
      {
        path: '/weavecolor/create',
        name: 'CreateWeaveColor',
        component: CreateWeaveColor,
        routeComponent: UserRoute,
      },
      {
        path: '/weavecolor/edit/:id',
        name: 'UpdateWeaveColor',
        component: UpdateWeaveColor,
        routeComponent: UserRoute,
      },
      {
        path: '/currency',
        name: 'Currency',
        component: Currency,
        routeComponent: UserRoute,
      },
      {
        path: '/currency/create',
        name: 'CreateCurrency',
        component: CreateCurrency,
        routeComponent: UserRoute,
      },
      {
        path: '/currency/edit/:id',
        name: 'UpdateCurrency',
        component: UpdateCurrency,
        routeComponent: UserRoute,
      },
      {
        path: '/weavetype',
        name: 'WeaveType',
        component: WeaveType,
        routeComponent: UserRoute,
      },
      {
        path: '/weavetype/create',
        name: 'CreateWeaveType',
        component: CreateWeaveType,
        routeComponent: UserRoute,
      },
      {
        path: '/suppliertype',
        name: 'SupplierType',
        component: SupplierType,
        routeComponent: UserRoute,
      },
      {
        path: '/suppliertype/create',
        name: 'CreateSupplierType',
        component: CreateSupplierType,
        routeComponent: UserRoute,
      },
      {
        path: '/suppliertype/edit/:id',
        name: 'UpdateSupplierType',
        component: UpdateSupplierType,
        routeComponent: UserRoute,
      },
      {
        path: '/weavetype/edit/:id',
        name: 'UpdateWeaveType',
        component: UpdateWeaveType,
        routeComponent: UserRoute,
      },
      {
        path: '/users/details/:userId',
        name: 'UserDetails',
        component: UserDetails,
        routeComponent: UserRoute,
      },
      {
        path: '/customers',
        name: 'Customers',
        component: Customer,
        routeComponent: UserRoute,
      },
      {
        path: '/customers/create',
        name: 'CreateCustomer',
        component: CreateCustomer,
        routeComponent: UserRoute,
      },
      {
        path: '/customers/edit/:id',
        name: 'UpdateCustomer',
        component: UpdateCustomer,
        routeComponent: UserRoute,
      },
      {
        path: '/suppliers',
        name: 'Suppliers',
        component: Supplier,
        routeComponent: UserRoute,
      },
      {
        path: '/suppliers/create',
        name: 'CreateSupplier',
        component: CreateSupplier,
        routeComponent: UserRoute,
      },
      {
        path: '/suppliers/edit/:id',
        name: 'UpdateSupplier',
        component: UpdateSupplier,
        routeComponent: UserRoute,
      },
      {
        path: '/shipments',
        name: 'Shipments',
        component: require('./pages/Shipment/Shipment').default,
        routeComponent: UserRoute,
      },
      {
        path: '/shipments/create',
        name: 'CreateShipment',
        component: require('./pages/CreateShipment/CreateShipment').default,
        routeComponent: UserRoute,
      },
      {
        path: '/shipments/edit/:id',
        name: 'UpdateShipment',
        component: require('./pages/UpdateShipment/UpdateShipment').default,
        routeComponent: UserRoute,
      },
      {
        path: '/orders',
        name: 'Orders',
        component: require('./pages/Order/Order').default,
        routeComponent: UserRoute,
      },
      {
        path: '/orders/create',
        name: 'CreateOrder',
        component: require('./pages/CreateOrder/CreateOrder').default,
        routeComponent: UserRoute,
      },
      {
        path: '/orders/edit/:id',
        name: 'UpdateOrder',
        component: require('./pages/UpdateOrder/UpdateOrder').default,
        routeComponent: UserRoute,
      },
      {
        path: '/orders/detail/:id',
        name: 'OrderDetails',
        component: OrderDetails,
        routeComponent: UserRoute,
      },
      {
        path: '/orders/action/:id',
        name: 'OrderAction',
        component: OrderAction,
        routeComponent: UserRoute,
      },
      {
        path: '/orders/supplier/:id',
        name: 'OrderSupplier',
        component: OrderSupplier,
        routeComponent: UserRoute,
      },
      {
        path: '/products',
        name: 'Products',
        component: Product,
        routeComponent: UserRoute,
      },
      {
        path: '/products/create',
        name: 'CreateProduct',
        component: CreateProduct,
        routeComponent: UserRoute,
      },
      {
        path: '/products/edit/:id',
        name: 'UpdateProduct',
        component: UpdateProduct,
        routeComponent: UserRoute,
      },
      {
        path: '/samples',
        name: 'Samples',
        component: Sample,
        routeComponent: UserRoute,
      },
      {
        path: '/samples/create',
        name: 'CreateSample',
        component: CreateSample,
        routeComponent: UserRoute,
      },
      {
        path: '/samples/edit/:id',
        name: 'UpdateSample',
        component: UpdateSample,
        routeComponent: UserRoute,
      },
      {
        path: '/stock',
        name: 'Stock',
        component: Stock,
        routeComponent: UserRoute,
      },
      {
        path: '/stock/create',
        name: 'CreateStock',
        component: CreateStock,
        routeComponent: UserRoute,
      },
      {
        path: '/stock/edit/:id',
        name: 'UpdateStock',
        component: UpdateStock,
        routeComponent: UserRoute,
      },
      {
        path: '/order',
        name: 'Order',
        component: Order,
        routeComponent: UserRoute,
      },
      {
        path: '/order/create',
        name: 'CreateOrder',
        component: CreateOrder,
        routeComponent: UserRoute,
      },
      {
        path: '/order/edit/:id',
        name: 'UpdateOrder',
        component: UpdateOrder,
        routeComponent: UserRoute,
      },
      {
        path: '/reports/customer-agreement',
        name: 'CustomerAgreementReport',
        component: CustomerAgreementReport,
        routeComponent: UserRoute,
      },
      {
        path: '/reports/caglik-reports',
        name: 'CaglikReport',
        component: CaglikReport,
        routeComponent: UserRoute,
      },
      {
        path: '/reports/sample-report',
        name: 'SampleReport',
        component: SampleReport,
        routeComponent: UserRoute,
      },


    ],
  },
};

export default routes;